import { useContext } from 'react';
import ReactDOM from 'react-dom';
import { ModalContext } from '../../../store/modal-context';

const Modal = (props) => {
  const {
    modalTitle,
    modalSubtitle,
    modalContent,
    handleModal,
    modal,
    showClose = false,
  } = useContext(ModalContext);

  if (modal) {
    return ReactDOM.createPortal(
      <div
        className={`modal-backdrop ${
          props.active === true ? 'modal-backdrop--active' : ''
        }`}
      >
        <div className="modal">
          {showClose && (
            <button className="modal__close" onClick={() => handleModal()}>
              &times;
            </button>
          )}
          {modalTitle && <h2 className="modal__title">{modalTitle}</h2>}
          {modalSubtitle && <p className="modal__subtitle">{modalSubtitle}</p>}
          {modalContent && <div className="modal__body">{modalContent}</div>}
        </div>
      </div>,
      document.getElementById('modal-root'),
    );
  } else {
    return null;
  }
};

export default Modal;
